import { PicturePack } from "@tblabs/storage";
import { Collection } from "@tblabs/truffle";

export enum ContentType
{
    Message = "message",
    Pictures = "pictures",
}

export abstract class ChatEntry
{
    public Id = "";
    public Time = "";
    public AuthorId = "";
    public ContentType = ContentType.Message;
    public Content = "";

    constructor(id: string, time: string, userId: string, contentType: ContentType, content: string) 
    {
        this.Id = id;
        this.Time = time;
        this.AuthorId = userId;
        this.ContentType = contentType;
        this.Content = content;
    }
}

export class MessageChatEntry extends ChatEntry
{
    public Message = "";

    constructor(id: string, time: string, userId: string, content: string) 
    {
        super(id, time, userId, ContentType.Message, content);
    }
}

export class PictureChatEntry extends ChatEntry
{
    public Pictures = new Collection<PicturePack>();

    constructor(id: string, time: string, userId: string, content: string) 
    {
        super(id, time, userId, ContentType.Pictures, content);

        const pictures = JSON.parse(content);
        
        this.Pictures.Load(...pictures);
    }
}
